import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../../../Assets/Images/logo3.png";
import { AuthContext } from "../../../Contexts/Authprovider/Authprovider";

const Header = () => {
  const { user, logOut } = useContext(AuthContext);

  const handleLogout = () => {
    logOut()
      .then(() => {})
      .catch((error) => console.log(error));
  };

  const menuItems = (
    <>
      <li>
        <Link to="/">Home</Link>
      </li>
      {user?.email ? (
        <>
          <li>
            <Link to="/myreviews">
              <button className="btn-ghost">My Reviews</button>
            </Link>
          </li>
          <li>
            <Link to="/addservice">
              <button className="btn-ghost">Add Service</button>
            </Link>
          </li>
          <li>
            <button onClick={handleLogout} className="btn-ghost">
              Sign Out
            </button>
          </li>
        </>
      ) : (
        <>
          <li>
            <Link to="/login">Login</Link>
          </li>
          <li>
            <Link to="/signup">Sign Up</Link>
          </li>
        </>
      )}
      <Link to="blogs">
          <button className="btn btn-ghost">Blogs</button>
        </Link>
    </>
  );

  return (
    <div className="navbar mt-2 mb-3 py-5 bg-base-100">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content font-semibold mt-3 p-2 shadow bg-base-100 rounded-box w-52"
          >
            {menuItems}
          </ul>
        </div>
        <Link className="btn btn-ghost normal-case text-xl" to="/">
          <img width={80} src={logo} alt="" />
          <span>Turjo's Photography</span>
        </Link>
      </div>
      <div className="navbar-end hidden lg:flex">
        <ul className="menu menu-horizontal p-0 font-semibold">{menuItems}</ul>
      </div>
      {/* <div className="navbar-end">
        <Link to="blogs">
          <button className="btn btn-ghost">Blogs</button>
        </Link>
      </div> */}
    </div>
  );
};

export default Header;
